import axios from 'axios';

export const getSignedUrl = async (key, newToken) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signed-url`,
      {
        headers: { Authorization: newToken },
        params: { key },
      }
    );

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getYousignFile = async (signingRequestId, token) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestId}/documents/download`,
      headers: {
        accept: 'application/zip, application/pdf',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
      responseType: 'blob',
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

export const getAllProfileFiles = async (
  id,
  limit,
  offset,
  newToken,
  active
) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/documents/${id}`,
      params: { limit, offset, active },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteFile = async ({ documentId, newToken }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/documents/${documentId}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteCondoFile = async ({ id, key, field, newToken }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/condos/${id}/files`,
      data: { key, field },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
